import templateUrl from "./radio-template.html";

export const radioTemplateComponent = {
  bindings: {
    title: "@",
    options: "<",
    onChange: "&",
    isRequired: "<",
    searchText: "<",
    defaultSelectedOptionId: "@",
  },
  templateUrl,

  controller: class RadioTemplateComponent {
    $onInit() {
      this.name = new Date().getTime() + Math.random();
      if (this.isRequired === undefined) {
        this.isRequired = true;
      }
    }

    _onChange() {
      this.onChange({
        $event: {
          id: this.defaultSelectedOptionId,
        },
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/radio-template/radio-template.component.js